"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateItineraryTransferRateMatrix = void 0;
const dayjs = require("dayjs");
const isBetween = require("dayjs/plugin/isBetween");
dayjs.extend(isBetween);
const getBestTransferRate_1 = require("../transfers/getBestTransferRate");
const generateItineraryTransferRateMatrix = async (supabase, rates, data, hotel_areas, course_areas, areas, margin_discount_percentage, default_historic_price_increase) => {
    const trip_start = dayjs(data.trip.start_date);
    const duration = (data.trip.duration_days_nights || 0) + 1;
    const dates = Array.from({ length: duration }, (_, i) => trip_start.add(i, "day").format("YYYY-MM-DD"));
    const standard_rates = rates.filter((rate) => rate.type === "STANDARD_RATE");
    const custom_rates = rates.filter((rate) => rate.type === "CUSTOM_RATE");
    const rate_matrix = [];
    const num_golfers = (data.trip.number_of_golfers || 0) + (data.trip.pga_pros?.count || 0);
    const total_travelers = num_golfers + (data.trip.number_of_non_golfers || 0);
    // Helper function to create rate promise
    const createRatePromise = async (from_area, to_area, via_area, type, date, num_travelers, rate_type, rates_array) => {
        const rate = await (0, getBestTransferRate_1.getBestTransferRate)(supabase, rates_array, {
            id: from_area.id,
            name: from_area.name?.en,
            type: from_area.type,
            address: from_area.name?.en,
        }, {
            id: to_area.id,
            name: to_area.name?.en,
            type: to_area.type,
            address: to_area.name?.en,
        }, via_area
            ? {
                id: via_area.id,
                name: via_area.name?.en,
                type: via_area.type,
                address: via_area.name?.en,
            }
            : null, type, date, num_travelers, margin_discount_percentage, default_historic_price_increase);
        if (rate) {
            rate_matrix.push({
                date,
                from: from_area.id,
                to: to_area.id,
                via: via_area?.id || null,
                type: rate_type,
                rate,
            });
        }
    };
    // Process custom rates (only for first and last dates)
    const customRatePromises = dates
        .filter((_, i) => i === 0 || i === dates.length - 1)
        .flatMap((date) => areas.flatMap((from_area) => course_areas.flatMap((via_area) => [
        // Area > Course > Area
        ...areas.flatMap((to_area) => createRatePromise(from_area, to_area, via_area, "CUSTOM", date, num_golfers, "CUSTOM_RATE", custom_rates)),
        ...areas.flatMap((to_area) => createRatePromise(to_area, from_area, via_area, "CUSTOM", date, num_golfers, "CUSTOM_RATE", custom_rates)),
        ...hotel_areas.flatMap((to_area) => createRatePromise(from_area, to_area, via_area, "CUSTOM", date, num_golfers, "CUSTOM_RATE", custom_rates)),
        ...hotel_areas.flatMap((to_area) => createRatePromise(to_area, from_area, via_area, "CUSTOM", date, num_golfers, "CUSTOM_RATE", custom_rates)),
    ])));
    // Process standard rates
    const standardRatePromises = dates.flatMap((date) => [
        // Hotel to course transfers
        ...hotel_areas.flatMap((hotel) => course_areas.map((course) => createRatePromise(hotel, course, null, "RETURN", date, num_golfers, "STANDARD_RATE", standard_rates))),
        // Area to hotel transfers
        ...areas.flatMap((area) => [
            ...hotel_areas.map((hotel) => createRatePromise(area, hotel, null, "ONE_WAY", date, total_travelers, "STANDARD_RATE", standard_rates)),
            // Area to course transfers
            ...course_areas.map((course) => createRatePromise(area, course, null, "RETURN", date, num_golfers, "STANDARD_RATE", standard_rates)),
        ]),
    ]);
    // Wait for all promises to resolve
    await Promise.all([...standardRatePromises, ...customRatePromises].filter(Boolean));
    return rate_matrix;
};
exports.generateItineraryTransferRateMatrix = generateItineraryTransferRateMatrix;
